import { groupNoteText, NOTE_GENERIC } from '../../../lib/deskGroupNote'

export function GroupNote({ applied, text = NOTE_GENERIC }: { applied: boolean | undefined; text?: string }) {
  const shown = groupNoteText(applied, text)
  if (shown === null) return null
  return <p role="note" className="border border-ink-500 bg-ink-800 px-2 py-1 font-mono text-[12px] text-paper-dim">{shown}</p>
}
